import React from "react";
import AssessmentIcon from "@material-ui/icons/Assessment";
import { ROUTE_PAGE } from "./RoutePage";
import { ROLES } from "constants/index";
import BusinessIcon from "@material-ui/icons/Business";
import PeopleIcon from "@material-ui/icons/People";
import DirectionsBusIcon from "@material-ui/icons/DirectionsBus";
import RoomIcon from "@material-ui/icons/Room";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import StoreIcon from "@material-ui/icons/Store";
import EventIcon from "@material-ui/icons/Event";
import NaturePeopleIcon from "@material-ui/icons/NaturePeople";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import SearchIcon from "@material-ui/icons/Search";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import SettingsIcon from "@material-ui/icons/Settings";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import AssignmentIcon from "@material-ui/icons/Assignment";
import FeaturedPlayListIcon from "@material-ui/icons/FeaturedPlayList";
import { ReactComponent as BusquedaIcono } from "assets/icono/busqueda1.svg";
import { ReactComponent as PasajeroIcono } from "assets/icono/pasajeros1.svg";
import { ReactComponent as EmbarqueIcono } from "assets/icono/carga1.svg";
import { ReactComponent as RutaIcono } from "assets/icono/ruta1.svg";
import { ReactComponent as DesembarqueIcono } from "assets/icono/desembarque1.svg";
export const styleIconCustom = {
  fontSize: "2rem",
  width: "0.8em",
  height: "0.8em",
};
export const MenuConfig: any[] = [
  {
    nombre: "DashBoard",
    icon: <AssessmentIcon />,
    subMenu: [
      {
        nombre: "Empresas",
        link: ROUTE_PAGE.EMPRESA.LISTAR,
        component: React.lazy(
          () => import("Page/ajuste/empresa/EmpresaListar")
        ),
        icon: <BusinessIcon />,
        access: [ROLES.ADMINISTRADOR],
      },
      {
        nombre: "Acceso",
        link: ROUTE_PAGE.PRS_EMPRESA.LISTAR,
        component: React.lazy(() => import("Page/ajuste/acceso/AccesoListar")),
        icon: <PeopleIcon />,
        access: [ROLES.ADMINISTRADOR, ROLES.STAFF, ROLES.EMPRESA_TRANSPORTE],
      },
      {
        nombre: "Ubicación",
        link: ROUTE_PAGE.UBICACION.LISTAR,
        component: React.lazy(
          () => import("Page/ajuste/ubicacion/UbicacionListar")
        ),
        icon: <RoomIcon />,
        access: [ROLES.ADMINISTRADOR, ROLES.STAFF],
      },
      {
        nombre: "Terminal",
        link: ROUTE_PAGE.TERMINAL.LISTAR,
        component: React.lazy(
          () => import("Page/ajuste/terminal/TerminalLista")
        ),
        icon: <EmojiTransportationIcon />,
        access: [ROLES.ADMINISTRADOR, ROLES.STAFF],
      },
    ],
    access: [ROLES.ADMINISTRADOR],
    pages: [
      {
        link: ROUTE_PAGE.HOME.VER,
        component: React.lazy(() => import("Page/Home/Home")),
      },
      {
        link: ROUTE_PAGE.EMPRESA.CREAR,
        component: React.lazy(() => import("Page/ajuste/empresa/EmpresaCrear")),
      },
      {
        link: ROUTE_PAGE.EMPRESA.EDITAR,
        component: React.lazy(
          () => import("Page/ajuste/empresa/EmpresaEditar")
        ),
      },
      {
        link: ROUTE_PAGE.PRS_EMPRESA.NUEVO,
        component: React.lazy(() => import("Page/ajuste/acceso/AccesoCrear")),
      },
      {
        link: ROUTE_PAGE.PRS_EMPRESA.EDITAR,
        component: React.lazy(() => import("Page/ajuste/acceso/AccesoEditar")),
      },
      {
        link: ROUTE_PAGE.TERMINAL.NUEVO,
        component: React.lazy(
          () => import("Page/ajuste/terminal/TerminalCrear")
        ),
      },
      {
        link: ROUTE_PAGE.TERMINAL.EDITAR,
        component: React.lazy(
          () => import("Page/ajuste/terminal/TerminalEditar")
        ),
      },
    ],
  },
  {
    nombre: "Transporte",
    icon: <AssessmentIcon />,
    subMenu: [
      {
        nombre: "Bus/Camión",
        link: ROUTE_PAGE.TRANSPORTE.LISTAR,
        component: React.lazy(
          () => import("Page/transporte/mediotransporte/MedioTransporte")
        ),
        icon: <DirectionsBusIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
        ],
      },
    ],
    pages: [
      {
        link: ROUTE_PAGE.TRANSPORTE.CREAR,
        component: React.lazy(
          () => import("Page/transporte/mediotransporte/MedioTransporteCrear")
        ),
      },
      {
        link: ROUTE_PAGE.TRANSPORTE.EDITAR,
        component: React.lazy(
          () => import("Page/transporte/mediotransporte/MedioTransporteEditar")
        ),
      },
      {
        link: ROUTE_PAGE.TRANSPORTE.DESIGN2,
        component: React.lazy(
          () => import("Page/transporte/disenio2/DisenioBus")
        ),
      },
    ],
  },
  {
    nombre: "Viaje",
    icon: <AssessmentIcon />,
    subMenu: [
      {
        nombre: "Viaje",
        link: ROUTE_PAGE.VIAJE.LISTAR,
        component: React.lazy(() => import("Page/viaje/viaje/ViajeListar")),
        icon: <MenuBookIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BOLETERO,
          ROLES.BODEGUERO_BOLETERO,
        ],
      },
      {
        nombre: "Busqueda viaje",
        link: ROUTE_PAGE.VIAJE.BUSQUEDA_VIAJE,
        component: React.lazy(
          () => import("Page/viaje/busquedaviaje/BusquedaViaje")
        ),
        icon: <SearchIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BOLETERO,
          ROLES.BODEGUERO_BOLETERO,
        ],
      },
      {
        nombre: "Busqueda pasajero",
        link: ROUTE_PAGE.TUVI.LISTA,
        component: React.lazy(() => import("Page/viaje/reserva/Reserva")),
        icon: <PasajeroIcono style={styleIconCustom} />,
        access: [
          ROLES.ADMINISTRADOR,
          ROLES.STAFF,
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BOLETERO,
          ROLES.BODEGUERO_BOLETERO,
        ],
      },
      {
        nombre: "Otros servicios",
        link: ROUTE_PAGE.SERVICIO.LISTAR,
        component: React.lazy(
          () => import("Page/viaje/servicio/ServicioListar")
        ),
        icon: <AssignmentIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BOLETERO,
          ROLES.BODEGUERO_BOLETERO,
          ROLES.BODEGUERO,
        ],
      },
      {
        nombre: "Ruta",
        link: ROUTE_PAGE.RUTA.LISTA,
        component: React.lazy(() => import("Page/viaje/ruta/Ruta")),
        icon: <RutaIcono style={styleIconCustom} />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
        ],
      },
      {
        nombre: "Abordaje",
        link: ROUTE_PAGE.PUNTO_ABORDAJE.LISTA,
        component: React.lazy(() => import("Page/viaje/carril/Carril")),
        icon: <NaturePeopleIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
        ],
      },
    ],
    pages: [
      {
        link: ROUTE_PAGE.SERVICIO.EDITAR,
        component: React.lazy(
          () => import("Page/viaje/servicio/ServicioEditar")
        ),
      },
      {
        link: ROUTE_PAGE.SERVICIO.CREAR,
        component: React.lazy(
          () => import("Page/viaje/servicio/ServicioCrear")
        ),
      },
      {
        link: ROUTE_PAGE.PUNTO_ABORDAJE.NUEVO,
        component: React.lazy(() => import("Page/viaje/carril/CarrilCrear")),
      },
      {
        link: ROUTE_PAGE.PUNTO_ABORDAJE.EDITAR,
        component: React.lazy(() => import("Page/viaje/carril/CarrilEditar")),
      },
      {
        link: ROUTE_PAGE.RUTA.NUEVO,
        component: React.lazy(() => import("Page/viaje/ruta/RutaCrear")),
      },
      {
        link: ROUTE_PAGE.RUTA.HORARIO.LISTAR,
        component: React.lazy(() => import("Page/viaje/horario/HorarioListar")),
      },
      {
        link: ROUTE_PAGE.RUTA.HORARIO.CREAR,
        component: React.lazy(() => import("Page/viaje/horario/HorarioCrear")),
      },
      {
        link: ROUTE_PAGE.RUTA.HORARIO.EDITAR,
        component: React.lazy(() => import("Page/viaje/horario/HorarioEditar")),
      },
      {
        link: ROUTE_PAGE.RUTA.EDITAR,
        component: React.lazy(() => import("Page/viaje/ruta/RutaEditar")),
      },
      {
        link: ROUTE_PAGE.TRANSPORTE.CREAR,
        component: React.lazy(
          () => import("Page/transporte/mediotransporte/MedioTransporteCrear")
        ),
      },
      {
        link: ROUTE_PAGE.PLANILLA.VER,
        component: React.lazy(() => import("Page/viaje/planilla/Planilla")),
      },
      {
        link: ROUTE_PAGE.TRASLADO.LISTA,
        component: React.lazy(
          () => import("Page/viaje/traslado/TrasladoLista")
        ),
      },
      {
        link: ROUTE_PAGE.TRASLADO.CREAR,
        component: React.lazy(
          () => import("Page/viaje/traslado/crear/TrasladoCrear")
        ),
      },
      {
        link: ROUTE_PAGE.RUTA.TRAMO,
        component: React.lazy(() => import("Page/viaje/ruta/Tramos")),
      },
    ],
  },
  {
    nombre: "Encomienda",
    icon: <AllInboxIcon />,
    subMenu: [
      {
        nombre: "Busqueda guia",
        link: ROUTE_PAGE.SEGUIMIENTO.BUSCAR,
        component: React.lazy(
          () => import("Page/encomienda/busquedaguia/BusquedaGuia")
        ),
        icon: <BusquedaIcono style={styleIconCustom} />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BODEGUERO,
          ROLES.BODEGUERO_BOLETERO,
        ],
      },
      /* {
        nombre: "Seguimiento",
        link: ROUTE_PAGE.SEGUIMIENTO.BUSCAR,
        component: React.lazy(
          () => import("Page/encomienda/entregaguia/EntregaGuia")
        ),
        icon: <AllInboxIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BODEGUERO,
          ROLES.BODEGUERO_BOLETERO,
        ],
      }, */
      {
        nombre: "Guia",
        link: ROUTE_PAGE.SOLICITUD.LISTAR,
        component: React.lazy(() => import("Page/encomienda/guia/GuiaList")),
        icon: <FeaturedPlayListIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BODEGUERO,
          ROLES.BODEGUERO_BOLETERO,
        ],
      },
      /*  {
        nombre: "Guia",
        link: ROUTE_PAGE.SOLICITUD.NUEVO,
        component: React.lazy(() => import("Page/encomienda/guia/GuiaCrear")),
        icon: <AllInboxIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BODEGUERO,
          ROLES.BODEGUERO_BOLETERO,
        ],
      }, */
      {
        nombre: "Embarque",
        link: ROUTE_PAGE.ENCOMIENDA.EMBARQUE,
        component: React.lazy(
          () => import("Page/encomienda/embarque/Embarque")
        ),
        icon: <EmbarqueIcono style={styleIconCustom} />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BODEGUERO,
          ROLES.BODEGUERO_BOLETERO,
        ],
      },
      {
        nombre: "Desembarque",
        link: ROUTE_PAGE.ENCOMIENDA.DESEMBARQUE,
        component: React.lazy(
          () => import("Page/encomienda/desembarque/Desembarque")
        ),
        icon: <DesembarqueIcono style={styleIconCustom} />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
          ROLES.BODEGUERO,
          ROLES.BODEGUERO_BOLETERO,
        ],
      },
    ],
    pages: [
      {
        link: ROUTE_PAGE.SOLICITUD.NUEVO,
        component: React.lazy(() => import("Page/encomienda/guia/GuiaCrear")),
      },
      {
        link: ROUTE_PAGE.SOLICITUD.SEGUIMIENTO,
        component: React.lazy(
          () => import("Page/encomienda/entregaguia/EntregaGuia")
        ),
      },
    ],
  },
  {
    nombre: "Administración",
    icon: <AssessmentIcon />,
    subMenu: [
      {
        nombre: "Sucursal",
        link: ROUTE_PAGE.SUCURSAL.LISTAR,
        component: React.lazy(
          () => import("Page/administracion/sucursal/Sucursal")
        ),
        icon: <StoreIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
        ],
      },
      {
        nombre: "Reporte",
        link: ROUTE_PAGE.REPORTE_GENERAL.LISTA,
        component: React.lazy(
          () => import("Page/administracion/reporte/Reporte")
        ),
        icon: <AttachMoneyIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
        ],
      },
      {
        nombre: "Planificación",
        link: ROUTE_PAGE.PLANIFICACION.NUEVO,
        component: React.lazy(
          () => import("Page/administracion/planifiacion/Planificacion")
        ),
        icon: <EventIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
        ],
      },
      {
        nombre: "Facturación",
        link: ROUTE_PAGE.NIT.LISTA,
        component: React.lazy(
          () => import("Page/administracion/nit/NitListar")
        ),
        icon: <AccountBalanceIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
        ],
      },
    ],
    pages: [
      {
        link: ROUTE_PAGE.SUCURSAL.NUEVO,
        component: React.lazy(
          () => import("Page/administracion/sucursal/SucursalCrear")
        ),
      },
      {
        link: ROUTE_PAGE.SUCURSAL.EDITAR,
        component: React.lazy(
          () => import("Page/administracion/sucursal/SucursalEditar")
        ),
      },
      {
        link: ROUTE_PAGE.NIT.EDITAR,
        component: React.lazy(
          () => import("Page/administracion/nit/NitEditar")
        ),
      },
      {
        link: ROUTE_PAGE.NIT.SUCURSAL,
        component: React.lazy(
          () => import("Page/administracion/nit/NitSucursal")
        ),
      },
      {
        link: ROUTE_PAGE.NIT.NUEVO,
        component: React.lazy(() => import("Page/administracion/nit/NitCrear")),
      },
      {
        link: ROUTE_PAGE.NIT.LIBRO_VENTA,
        component: React.lazy(
          () => import("Page/administracion/nit/LibroVenta")
        ),
      },
      {
        link: ROUTE_PAGE.NIT.CERTIFICACION,
        component: React.lazy(
          () => import("Page/administracion/nit/Certificacion")
        ),
      },
    ],
  },
  {
    nombre: "Configuración",
    icon: <AssessmentIcon />,
    subMenu: [
      {
        nombre: "Configuración",
        link: ROUTE_PAGE.CONFIGURACION.IMPRESORA,
        component: React.lazy(() => import("Page/configuracion/Configuracion")),
        icon: <SettingsIcon />,
        access: [
          ROLES.EMPRESA_TRANSPORTE,
          ROLES.ADM_REGIONAL,
          ROLES.ADM_REGIONAL_SIN_ANULAR,
        ],
      },
    ],
    page: [],
  },
];
